<template>
<div class="content_card">
<div class="grid">



<div class="col-12 md:col-2">
<div class="content_card_content sticky_panel">
<h4 class=" text-primary">{{brandname}}</h4>

<Divider />
<small class="text-purple-500 font-bold">{{date}}</small>
</div>
</div>



<div class="col-12 md:col-10">
<div class="content_card_content">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-else>
<h4 class="text-primary font-bold">{{title}}</h4>
<div v-html="message"></div>
</template>

</div>
</div>	



</div>


</div>
</template>

<script>
export default {

  name: 'UserNotification',

  data () {
    return {
    	loading:true,
    	item:null,
    }
  },
  
  mounted()
  {
  	this.$store.dispatch('ui/setShowNotificationsModal',false)
  	this.getData()
  },
  computed:{
  	date()
  	{
  		if(this.item && this.item.brandnotification )
  		{
  			return this.$filters.momentFormat( this.item.created_at," DD-MM-YYYY HH:mm")
  		}
  		return null
  	},
  	brandname()
  	{
  		if(this.item && this.item.brandnotification && this.item.brandnotification.brand)
  		{
  			return this.item.brandnotification.brand.name
  		}
  		return null
  	},
  	title()
  	{
  		let translation = this.item.brandnotification.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  		if(translation)
  		{
  			return translation.translation
  		}
  		return item.name
  	},
  	message()
  	{
  		let translation = this.item.brandnotification.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  		if(translation)
  		{
  			return translation.message
  		}
  		return null
  	},
  },
  methods:{
  	async getData()
  	{
  		this.item = await this.generalApiGetWithoutLoader("get_supplier_notification/"+this.$route.params.notification_uuid)
  		this.getSupplierOpenNotifications()
  		console.log(this.item)
  		this.loading = false 
  	}
  }
}
</script>

<style lang="css" scoped>
</style>